import DocumentClickedMixin from '@/mixins/document-click';
import DropdownList from '@/components/forms/dropdown/dropdown-list';
import { isUndefinedOrNull, isObject, isArray } from '@/utils/inspect';
import { hasOwnProperty } from '@/utils/object';
import { hasKeys } from '@/utils/function';

const dropdownMixin = {
	mixins: [DocumentClickedMixin('closeHandler', 'renderList')],
	components: {
		DropdownList
	},
	props: {
		width: {
			type: Number,
			default: undefined
		},
		autosuggestion: {
			type: Boolean,
			default: false
		},
		errorText: {
			type: String,
			default: ''
		},
		helpText: {
			type: String,
			default: ''
		},
		label: {
			type: String,
			default: ''
		},
		multiSelect: {
			type: Boolean,
			default: false
		},
		zone: {
			type: Boolean,
			default: false
		},
		options: {
			type: Array,
			default: () => []
		},
		renderList: {
			type: Boolean,
			default: true
		},
		showClearSelectedButton: {
			type: Boolean,
			default: true
		},
		value: {
			// type: String, Number, Object, Array,
			default: null
		},
		defaultValue: {
			// type: String, Number, Object, Array,
			default: ''
		},
		required: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			isOpen: false,
			items: [],
			toggleMenu: () => {
				return (this.isOpen = !this.isOpen);
			},
			menuOnTop: false,
			popperMinWidth: 'auto'
		};
	},
	computed: {
		hasError() {
			return !!this.errorText;
		}
	},
	methods: {
		closeHandler() {
			this.isOpen = false;
		},
		validateOption(option, keys) {
			if (!isObject(option)) {
				`[dropdown warn]: "option" must be an object.\n`;
				return null;
			}

			if (isUndefinedOrNull(keys) || !isArray(keys) || keys.length == 0) {
				`[dropdown warn]: "keys" is required.\n`;
				return null;
			}

			for (let index = 0; index < keys.length; index++) {
				if (!hasOwnProperty(option, keys[index])) {
					console.warn(
						`[dropdown warn]: "${keys[index]}" key does not exist in option object .\n`
					);
					option = null;
					break;
				}
			}

			return option;
		},
		handleKeyUp(e) {
			if (e.keyCode === 13 || e.keyCode === 32) {
				this.toggleMenu();
			}
		},
		updateIconOrientation(e) {
			this.menuOnTop = e.includes('top') ? true : false;
		}
	},
	watch: {
		options: {
			deep: true,
			immediate: true,
			handler(options) {
				if (options && options.length > 0) {
					if (!hasKeys(options[0], ['text', 'value'])) {
						this.items = options.map(op => {
							return {
								text: op.toString(),
								value: op
							};
						});
					} else {
						this.items = [...options];
					}
				} else {
					this.items = [];
				}
			}
		}
	}
};

export default dropdownMixin;
